import React from 'react'

import Select from 'react-select'
import axios from 'axios'
import {getToken} from '../../../storage'
import {API_BASE_URL} from '../../../constants'

import {AddClientModal} from '../../modal/modal'

class ClientNameExtended extends React.Component {

  render() {

    const option = this.props.option


    return  <div>
            <div>
                {option.name}
            </div>
            <div>
                {option.gstin}
            </div>
            <div>
                <strong>{option.address} {option.city}</strong>
            </div>
    </div>
  }
}

class ClientWithCity extends React.Component {

  render() {
    const option = this.props.option
    return <div>{option.name} {option.city}</div>
  }
}

export default class ClientElement extends React.Component {

  constructor(props){
    super(props)
    this.handleChange=this.handleChange.bind(this)
    this.createClientPromt = this.createClientPromt.bind(this)
    this.renderOption = this.renderOption.bind(this)
    this.renderValue = this.renderValue.bind(this)
    this.state={showClientCreate:false}
    this.handleClientModal = this.handleClientModal.bind(this)
  }
  handleClientModal() {
    this.setState({
      showClientCreate:false
    })
  }

  createClientPromt(input){
    return "Create new client ?"
  }

  handleChange(client){
    if(client !== null && typeof client.className !== "undefined" ) {
      // Do not add client for random inputs
        this.setState({showClientCreate:true})
    }
    else {
      if (typeof this.props.onAddCallback !== "undefined") {
        this.props.onAddCallback(client)
      }
      this.setState({showClientCreate:false})
    }
  }

  getClients (input) {


    if (!input) {
      return Promise.resolve({ options: [] });
    }

    return   axios({
        url: '/list_clients/?q='+input,
        method: 'get',
        baseURL: API_BASE_URL,
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          }

        }
      }).then((response)=> {
            return {options: response.data.clients}
      }).catch((err)=> {
        return Promise.resolve({ options: [] });
      })
}

renderOption(option) {
  return <ClientNameExtended option={option} />
}

renderValue(option) {
  return <ClientWithCity option ={option} />
}

  render() {


    let inputValue
    if(typeof this.props.invoice !== "undefined") {
      inputValue = this.props.invoice.client
    }

    let clientModal = <AddClientModal show={this.state.showClientCreate} handleModalToggle={this.handleClientModal} onAddCallback={this.handleChange} />



    return <div>
          {clientModal}
      <Select.AsyncCreatable name="name" placeHolder="select client"
     value={inputValue}  valueKey="id" labelKey="name" loadOptions={this.getClients}
     optionRenderer={this.renderOption} valueRenderer={this.renderValue}
    onChange={this.handleChange} promptTextCreator={this.createClientPromt} autoFocus />
 </div>
  }
}







export class DepartmentElement extends React.Component {

  constructor(props){
    super(props)
    this.handleChange=this.handleChange.bind(this)
    this.renderOption = this.renderOption.bind(this)
    this.renderValue = this.renderValue.bind(this)
    this.state={showClientCreate:false}

  }



  handleChange(department){
    if(department !== null && typeof department.className !== "undefined" ) {
      // Do not add client for random inputs
        this.setState({showClientCreate:true})
    }
    else {
      if (typeof this.props.onAddCallback !== "undefined") {
        this.props.onAddCallback(department)
      }
      this.setState({showClientCreate:false})
    }
  }

  getDepartments (input) {


    if (!input) {
      return Promise.resolve({ options: [] });
    }

    return   axios({
        url: '/list_departments/?q='+input,
        method: 'get',
        baseURL: API_BASE_URL,
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          }

        }
      }).then((response)=> {
            return {options: response.data.departments}
      }).catch((err)=> {
        return Promise.resolve({ options: [] });
      })
}

renderOption(option) {
  return <div>{option.name} {option.phone}</div>
}

renderValue(option) {
  return <div>{option.name}</div>
}

  render() {


    let inputValue
    if(typeof this.props.invoice !== "undefined") {
      inputValue = this.props.invoice.department
    }





    return <div>

      <Select.Async name="name" placeHolder="select department"
     value={inputValue}  valueKey="id" labelKey="name" loadOptions={this.getDepartments}
     optionRenderer={this.renderOption} valueRenderer={this.renderValue}
    onChange={this.handleChange} autoFocus />
 </div>
  }
}



// WEBPACK FOOTER //
// ./src/components/invoice/rowelements/clientelement.js